module.exports = __webpack_public_path__ + "img/JS.89d2c97e.png";